import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkToTemplateDetail } from "../../../routes";

import "./TemplateTile.scss";

const TemplateTile = ({ template, workspaceId }) => {
  const nav = useNavigate();
  const [imageError, setImageError] = useState(false);

  const handleClick = () => {
    nav(linkToTemplateDetail(workspaceId, template.uid));
  };

  const hasScreenshot = template.screenshotUrl && !imageError;

  return (
    <div className="template_tile" onClick={handleClick}>
      <div className="thumbnail_container">
        {hasScreenshot ? (
          <img
            src={template.screenshotUrl}
            alt={template.name}
            className="thumbnail"
            onError={() => setImageError(true)}
          />
        ) : (
          <img
            src="/app/images/template-placeholder.jpg"
            alt={template.name}
            className="thumbnail"
          />
        )}
        {template.isGlobal && (
          <span className="category_badge">Global</span>
        )}
      </div>
      <div className="tile_content">
        <h3 className="template_name">{template.name}</h3>
        {template.modules && template.modules.length > 0 && (
          <span className="modules_info">{template.modules.join(", ")}</span>
        )}
      </div>
    </div>
  );
};

export default TemplateTile;
